import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { Tooltip } from '@mui/material';
import Toast from '../../helpers/Toast';
import { AssistanceListDTO } from '../../models/Assistance/AssistanceListDTO';
import { CreateAssistanceDTO } from '../../models/Assistance/CreateAssistanceDTO';
import { GetAssistanceFromProjectDTO } from '../../models/Project/GetAssistancesFromProjectDTO';
import { AssistanceService } from '../../services/AssistanceService';
import TableComponent from '../TableComponent';
import { FcViewDetails } from 'react-icons/fc';
import { FormattedMessage } from 'react-intl';
import { Utilities } from '../../helpers/Utilities';
import { ProjectService } from '../../services/ProjectService';

type  AssistancesFromProjectProps = {
    ProjectErp: string,
}

function AssistancesFromProject(props: AssistancesFromProjectProps) {
    
    const assistanceService = new AssistanceService();
    const projectService = new ProjectService();
    const navigate = useNavigate();
    const [assistances, setAssistances] = useState<AssistanceListDTO[]>([]);
    const pageSizes: number[] = [5, 15, 30];
    const [pageSize, setPageSize] = useState<number>(pageSizes[0]);
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [goToPage, setGoToPage] = useState<number>();
    const [pageCount, setPageCount] = useState(1);
    const [isButtonCreateLoading, setIsButtonCreateLoading] = useState<boolean>(false);

    const columns = React.useMemo(
        () => [
            {
                Header: "Assistência",
                Cell: (props: any) => {
                    return Utilities.FormattedAssistanceDocument(props.cell.row.original.docType, props.cell.row.original.serie, props.cell.row.original.number);
                },
                width: 12,
            },
            {
                Header: "Técnico",
                accessor: "technician",
                width: 12,
            },
            {
                Header: "Data",
                Cell: (props: any) => {
                    return Utilities.formatDate(new Date(props.cell.row.original.date));
                },
                width: 12,
            },
            {
                Header: "Estado",
                accessor: "status",
                width: 12,
            },
            {
                Header: "",
                accessor: " ",
                Cell: (props: any) => {
                    return (
                        <Tooltip
                            title="Ver Detalhes"
                            aria-label="Ver Detalhes"
                            enterNextDelay={500}
                            enterDelay={500}>
                            <div
                                style={{
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    alignContent: "center",
                                    flexDirection: "column",
                                    cursor: "pointer"
                                }}
                                onClick={() => {
                                    // Verificamos se cada campo 'relacionado' existe antes de passar para a função
                                    const projectErpId = props.cell.row.original.project?.erpId || null;
                                    const equipmentErpId = props.cell.row.original.equipment?.erpId || null;
                                    const equipmentNumSerie = props.cell.row.original.equipment?.serialNumber || null;
                                    const equipmentBrand = props.cell.row.original.equipment?.brand || null;
                                    const equipmentModel = props.cell.row.original.equipment?.model || null;
                                    const clientErpId = props.cell.row.original.client?.erpId || null;
                                    const number = props.cell.row.original.number;
                                    const docType = props.cell.row.original.docType;
                                    const serie = props.cell.row.original.serie;

                                    createAssistance(projectErpId, equipmentErpId, equipmentNumSerie, equipmentBrand, equipmentModel, clientErpId, number, docType, serie.toString());
                                }}
                            >
                                <FcViewDetails className="icons" />
                            </div>
                        </Tooltip>
                    );
                },
                width: 2,
            },
           
        ],
        [isButtonCreateLoading],
    );

    const createAssistance = async (projectErpId: string, equipmentErpId: string, equipmentNumSerie: string, equipmentBrand: string, equipmentModel: string, clientErpId: string, numDoc: number, typeDoc: string, serie: string) => {
        var sendData: CreateAssistanceDTO = {
            equipmentErpId: equipmentErpId,
            equipmentNumSerie: equipmentNumSerie,
            equipmentBrand: equipmentBrand,
            equipmentModel: equipmentModel,
            projectErpId: projectErpId,
            clientErpId: clientErpId,
            numDoc: numDoc,
            typeDoc: typeDoc,
            serie: serie,
            id: 0,
            date: new Date(),
            description: null,
            notes: null,
            clientId: null,
            counter1: 0,
            counter2: 0,
            counter3: 0,
            assistanceType: null,
            stockEntryDocumentErpId: null,
            budgetSellingPrice: null,
            budgetCostPrice: null
        }
        setIsButtonCreateLoading(true);
        var response = await assistanceService.Create(sendData);
        setIsButtonCreateLoading(false);

        if (response.success === false) {
            Toast.Show("error", response.message);
            return;
        }
        navigate(`/Backoffice/Assistance/${response.obj}`);
    }

    const GetAssistances = async (page: number, pageSize: number) => {
        setIsLoading(true);

        const data : GetAssistanceFromProjectDTO = {
            ProjectErp: String(props.ProjectErp),
            CurrentPage: currentPage,
            PageSize: pageSize,
        }

        var response = await projectService.GetAssistancesFromProject(data);

        if(response.success === false)
        {
            Toast.Show("error", response.message);
            setIsLoading(false);
            return; 
        }

        setAssistances(response.items);
        setIsLoading(false);
        setPageCount(response.totalPages);
        setPageSize(pageSize);
        setCurrentPage(page);
        setGoToPage(0)
    }

    useEffect(()=> {
        if(props.ProjectErp !== "")
        {
            GetAssistances(currentPage ?? 1, pageSize ?? 5)
        }
    }, [props.ProjectErp, currentPage, pageSize])

  return (
        <div>
            <label style={{ margin: "0px", padding: "13px" }}><b><FormattedMessage id="Screens.EquipmentCreate.Assistances" /></b></label>
             <TableComponent 
                    columns={columns} 
                    data={assistances}
                    goToPage={goToPage}
                    initialPage={currentPage}
                    pageCount={pageCount}
                    initialPageSize={pageSize}
                    pageSizes={pageSizes}
                    manualPagination={true}
                    loading={isLoading}
                    fetchData={GetAssistances} 
                    initialSortBy={[]}
                    disableSortBy={true}
                />    
        </div>
    
  )
}

export default AssistancesFromProject